import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

const STORAGE_KEY = "lpg_company_auth";

export const api = axios.create({ baseURL: API_BASE });

api.interceptors.request.use((config) => {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored) {
      const parsed = JSON.parse(stored);
      if (parsed?.token) config.headers.Authorization = `Bearer ${parsed.token}`;
    }
  } catch { /* ignore */ }
  return config;
});

export function formatApiError(err) {
  const detail = err?.response?.data?.detail;
  if (detail == null) return err?.message || "Something went wrong";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export function fmt(n, d = 2) {
  const num = Number(n || 0);
  return num.toLocaleString("en-IN", { minimumFractionDigits: d, maximumFractionDigits: d });
}

// Alias used across components
export const formatMoney = fmt;

export function fmtInt(n) {
  return Number(n || 0).toLocaleString("en-IN");
}

export function todayISO() {
  return new Date().toISOString().slice(0, 10);
}

export function fmtDate(iso) {
  if (!iso) return "";
  try {
    const d = typeof iso === "string" && iso.length <= 10
      ? new Date(iso + "T00:00:00")
      : new Date(iso);
    return d.toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" });
  } catch { return iso; }
}

export function fmtDateTime(iso) {
  if (!iso) return "";
  try {
    return new Date(iso).toLocaleString("en-IN", {
      day: "2-digit", month: "short", year: "numeric",
      hour: "2-digit", minute: "2-digit", hour12: true,
    });
  } catch { return iso; }
}
